export function hideEmail(email, count = 3) {
    return (
        email.substr(0, count) +
        email.substr(count, email.indexOf("@") - count).replace(/[^\@]/g, "x") +
        email.substr(email.indexOf("@"), email.length)
    );
}
